<script setup lang="ts">
/**
 * Wave 1 — Property access modals (Agent C).
 * Decorative icon shown at the top of every modal.
 * Path data is copied verbatim from the design pack JSX (`ModalIcon`).
 */

export type ModalIconKind = 'lock' | 'shield' | 'doc' | 'commission' | 'availability' | 'phone';

const { kind = 'lock', accent = 'gold' } = defineProps<{
  kind?: ModalIconKind;
  accent?: 'gold' | 'green';
}>();

const tintClasses = computed(() =>
  accent === 'green' ? 'bg-success/12 text-success' : 'bg-gold-primary-100/15 text-gold-primary-120',
);
</script>

<template>
  <div
    class="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-xl"
    :class="tintClasses"
    aria-hidden="true"
  >
    <svg
      width="26"
      height="26"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <template v-if="kind === 'lock'">
        <path d="M5 11h14v10H5zM8 11V7a4 4 0 1 1 8 0v4" />
      </template>
      <template v-else-if="kind === 'shield'">
        <path d="M12 3l8 3v6c0 5-3.4 8.5-8 9.5C7.4 20.5 4 17 4 12V6l8-3z" />
        <path d="M9 12l2 2 4-4" />
      </template>
      <template v-else-if="kind === 'doc'">
        <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" />
        <path d="M14 3v5h5" />
        <path d="M9 13h6M9 17h4" />
      </template>
      <template v-else-if="kind === 'commission'">
        <path d="M12 2v20M17 5H9a3 3 0 0 0 0 6h6a3 3 0 0 1 0 6H7" />
      </template>
      <template v-else-if="kind === 'availability'">
        <rect
          x="3"
          y="5"
          width="18"
          height="16"
          rx="2"
        />
        <line
          x1="3"
          y1="10"
          x2="21"
          y2="10"
        />
        <line
          x1="8"
          y1="3"
          x2="8"
          y2="7"
        />
        <line
          x1="16"
          y1="3"
          x2="16"
          y2="7"
        />
      </template>
      <template v-else-if="kind === 'phone'">
        <path
          d="M22 16.9v3.1a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3 19.5 19.5 0 0 1-6-6 19.8 19.8 0 0 1-3-8.7A2 2 0 0 1 4.1 2H7a2 2 0 0 1 2 1.7c.1.9.3 1.8.6 2.7a2 2 0 0 1-.5 2.1L7.9 9.8a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.5c.9.3 1.8.5 2.7.6a2 2 0 0 1 1.7 2z"
        />
      </template>
    </svg>
  </div>
</template>
